import { SizableText, YStack } from '@mythical/ui'
import { MerchCollectiblesCallToAction as MerchCollectiblesCallToActionType } from 'app/blocks/merch-collectibles-call-to-action'
import React from 'react'
import { ButtonLink } from '../primitive/Button'
import Section from '../structure/Section'

interface Props {
  block: MerchCollectiblesCallToActionType
}

export const MerchCollectiblesCallToActionBlock: React.FC<Props> = ({
  block,
}) => {
  const { title, ctaLabel, ctaHref } = block

  if (!title || !ctaLabel || !ctaHref) return null

  return (
    <Section paddedX>
      <YStack
        w="100%"
        ai="center"
        jc="center"
        gap="$3.5"
        bg="$bgTertiary"
        br="$5"
        px="$4"
        py="$5"
      >
        <SizableText ff="$title" size="$m" ta="center" $gtSm={{ size: '$xl' }}>
          {title}
        </SizableText>
        <ButtonLink href={ctaHref} size="$4">
          {ctaLabel}
        </ButtonLink>
      </YStack>
    </Section>
  )
}
